import {
  Button,
  Classes,
  FileInput,
  Dialog,
  FormGroup,
  H5,
  InputGroup,
  Popover,
  Radio,
  RadioGroup,
  Switch,
  Divider,
} from "@blueprintjs/core";
import {
  MDBBtn,
  MDBCol,
  MDBRow,
} from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IEmpresa } from "../../model";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { toast } from "react-toastify";
import moment from "moment";
import { AppStore } from "../../stores/AppStore";
import { DecSefaStore } from "../../stores/dec_sefa/DecSefaStore";
import InfoModal from "../info-modal/InfoModal";
import { AppIcon } from "../utils/AppIcon";
import PhoneInput from 'react-phone-input-2'

const InputMask = require("react-input-mask");

interface EmpresaSefaProps {
}

interface EmpresaSefaState {
}

@observer
export default class EmpresaSefa
  extends React.Component<EmpresaSefaProps, EmpresaSefaState> {

  obs = observable({
    nome_certificado: "Selecione o certificado" as string,
    certificado: [] as any,
    open_termos_dec_sefa: false as boolean,
    open_ajuda: false as boolean,
    open_ajuda_ecac: false as boolean,
    open_ajuda_parcelamento: false as boolean,
    open_ajuda_dei: false,
  })

  constructor(props) {
    super(props);
  }

  handleFileInputChange = (event) => {
    const file = event.target.files[0];

    this.obs.nome_certificado = file.name
    this.obs.certificado = file

  };

  async handleImportCertificado() {

    if (this.obs.certificado.length == 0) {
      toast.error('Você precisa selecionar o Certificado!', {});
      return;
    }

    if (!EmpresaStore.obs.empresa_edit.senha_certificado_socio) {
      toast.error('Preencha a senha do certificado', {});
      return;
    }

    let senha: string = EmpresaStore.obs.empresa_edit.senha_certificado_socio
    let cnpj: string = EmpresaStore.obs.empresa_edit.cnpj
    let certificado: any = this.obs.certificado

    var data = new FormData();
    data.append("file", certificado);
    data.append("senha", senha);
    data.append("cnpj", cnpj);

    let resp = await EmpresaStore.handleImportCertificado(data)

    if (resp) {

      EmpresaStore.obs.empresa_edit.certificado_socio = resp

      toast.success('Certificado importado com sucesso', {});
    }
  }

  handleTermos(e: boolean) {

    EmpresaStore.obs.empresa_edit.dec_sefa_auto = e

    if (!AppStore.obs1.usuario.termos_dec && e) {

      this.obs.open_termos_dec_sefa = true

    }

  }

  async handleAceita() {

    this.obs.open_termos_dec_sefa = false

    let ret = await DecSefaStore.handleAceitaTermos()

    if (ret) {

      AppStore.obs1.usuario.termos_dec = true

    }

  }

  deletaCertificado = async () => {

    var cnpj = EmpresaStore.obs.empresa_edit.cnpj;

    let resp = await EmpresaStore.handleDeletaCertificadoSocio(cnpj);

    if (resp) {

      toast.success('Certificado deletado com sucesso', {});

      this.obs.nome_certificado = "Selecione o certificado"
      this.obs.certificado = []

      EmpresaStore.obs.empresa_edit.certificado_socio = ""
      EmpresaStore.obs.empresa_edit.senha_certificado_socio = ""

    }

  };

  handleChangeMetodo(value) {

    EmpresaStore.obs.empresa_edit.sefa_metodo_login = value.target.value
  }

  handleNaoAceita() {

    EmpresaStore.obs.empresa_edit.dec_sefa_auto = false

    this.obs.open_termos_dec_sefa = false

  }

  render() {

    return (

      <>

        <div style={{ width: 1000 }}>

          <MDBCol md="12">

            <FormGroup
              label="Dec Sefa automático"
              labelFor="dec_sefa"
            >
              <Switch
                className="select-regras"
                label={EmpresaStore.obs.empresa_edit.dec_sefa_auto ? "Ativado" : "Desativado"}
                checked={EmpresaStore.obs.empresa_edit.dec_sefa_auto}
                onChange={(e: any) => this.handleTermos(e.target.checked)}
              />
            </FormGroup>
          </MDBCol>

          {EmpresaStore.obs.empresa_edit.dec_sefa_auto ?

            <MDBCol md="12">

              <Switch
                label="Receber aviso de NOVAS MENSAGENS por WhatsApp"
                alignIndicator="right"
                checked={EmpresaStore.obs.empresa_edit.dec_sefa_message}
                onChange={(e: any) => EmpresaStore.obs.empresa_edit.dec_sefa_message = e.target.checked}
                style={{ width: "max-content", fontWeight: "bold" }}
              />

              {EmpresaStore.obs.empresa_edit.dec_sefa_message ? (<>

                <FormGroup helperText="Insira um número com DDD para receber avisos de novas mensagens.">
                  <PhoneInput
                    country={'br'}
                    enableSearch
                    excludeCountries={['us','ua','ru']}
                    value={EmpresaStore.obs.empresa_edit.dec_sefa_numero}
                    onChange={phone => EmpresaStore.obs.empresa_edit.dec_sefa_numero = phone }
                    inputClass="phone-input"
                    searchClass="phone-input-search"
                    disableSearchIcon
                  />

                </FormGroup>

              </>) : <br />}

            </MDBCol>

          :<></>}

          <Divider />
          <br />

          <MDBCol md="12">

            <FormGroup label="Como você deseja se autenticar na SEFA?" labelInfo={<>
              &nbsp;<AppIcon name="help" className="pulse-notification-pgdas" color="blue" style={{ cursor: "pointer" }} onClick={() => this.obs.open_ajuda = true} />
            </>
            }>
              <RadioGroup inline onChange={(e) => this.handleChangeMetodo(e)} selectedValue={EmpresaStore.obs.empresa_edit.sefa_metodo_login}>
                <Radio label="Certificado do Sócio" value="certificado" />
                <Radio disabled label="CPF e Senha" value="senha" />
                <Radio label="GOV (Certificado)" value="gov" />
                <Radio label="GOV (CPF / Senha)" value="gov_senha" />
                {/* <Radio label="GOV (Certificado Contador com Apuração)" value="gov_contador" /> */}
              </RadioGroup>
            </FormGroup>

          </MDBCol>

          {EmpresaStore.obs.empresa_edit.sefa_metodo_login == "certificado" && <>

            <MDBCol md="12">
              {EmpresaStore.obs.empresa_edit.certificado_socio
                ? (
                  <>
                    <h3 className="info-cert">
                      Essa empresa possui um certificado em uso. <b />(Validade:{" "} {moment(EmpresaStore.obs.empresa_edit.certificado_socio).format("DD/MM/YYYY")})
                    </h3>

                    <MDBRow md="12" style={{ marginLeft: 0 }}>
                      <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING} position="bottom-left">
                        <Button intent="danger" icon="trash">Excluir Certificado</Button>
                        <div>
                          <H5>Confirmar exclusão?</H5>
                          <p>Atenção, deseja realmente excluir o certificado?</p>

                          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15 }}>
                            <Button className={Classes.POPOVER_DISMISS} style={{ marginRight: 10 }}>Cancelar</Button>
                            <Button intent="danger" className={Classes.POPOVER_DISMISS} onClick={this.deletaCertificado}>Excluir</Button>
                          </div>
                        </div>
                      </Popover>
                    </MDBRow>

                  </>
                )
                : (
                  <>
                    <MDBRow>
                      <MDBCol md="6">
                        <FormGroup label="Selecionar Certificado Digital">
                          <FileInput text={this.obs.nome_certificado} className="bp3-fill bp3-file-input-has-selection input-file-certificado" onInputChange={this.handleFileInputChange} />
                        </FormGroup>
                      </MDBCol>

                      <MDBCol md="4">
                        <FormGroup label="Senha Certificado">
                          <InputGroup autoComplete="new-senha-certificado" name="new-senha-certificado" type="password" onChange={(e: any) => EmpresaStore.obs.empresa_edit.senha_certificado_socio = e.target.value} />
                        </FormGroup>
                      </MDBCol>

                      <MDBCol md="2">
                        <Button onClick={(e) => this.handleImportCertificado()} intent="primary" style={{ marginTop: 26 }}>Importar</Button>
                      </MDBCol>

                    </MDBRow>
                  </>
                )
              }

            </MDBCol>

          </>}

          {EmpresaStore.obs.empresa_edit.sefa_metodo_login == "senha" && <>

            <MDBCol md="12">

              <FormGroup label="CPF SEFA" labelFor="cpf" style={{ width: "49%", float: "left" }}>
                <InputMask
                  className="form-control"
                  mask="999.999.999-99"
                  autoComplete="cpf-sefa"
                  name="cpf-sefa"
                  value={EmpresaStore.obs.empresa_edit.cpf_sefa}
                  onChange={(e: any) => EmpresaStore.obs.empresa_edit.cpf_sefa = e.target.value}
                />
              </FormGroup>

              <FormGroup label="Senha SEFA" labelFor="senha" style={{ width: "49%", float: "left", marginLeft: "2%" }}>
                <InputGroup
                  type="password"
                  autoComplete="new-password-sefa"
                  name="new-password-sefa"
                  defaultValue={EmpresaStore.obs.empresa_edit.senha_sefa}
                  onChange={(e: any) => EmpresaStore.obs.empresa_edit.senha_sefa = e.target.value}
                />
              </FormGroup>

            </MDBCol>

          </>}

          {EmpresaStore.obs.empresa_edit.sefa_metodo_login == "gov_senha" && <>

            <MDBCol md="12">

              <div style={{ display: "flex" }}>
                <FormGroup label="CPF" labelFor="cpf" style={{ width: "50%" }}>
                  <InputMask
                    className="form-control"
                    mask="999.999.999-99"
                    autoComplete="cpf-gov"
                    name="cpf-gov"
                    value={EmpresaStore.obs.empresa_edit.cpf_gov}
                    onChange={(e: any) => EmpresaStore.obs.empresa_edit.cpf_gov = e.target.value}
                  />
                </FormGroup>

                <FormGroup label="Senha" labelFor="senha" style={{ width: "50%", marginLeft: 10 }}>
                  <InputGroup
                    type="password"
                    autoComplete="new-password-gov"
                    name="new-password-gov"
                    placeholder="*********"
                    defaultValue={EmpresaStore.obs.empresa_edit.senha_gov}
                    onChange={(e: any) => EmpresaStore.obs.empresa_edit.senha_gov = e.target.value}
                  />
                </FormGroup>
              </div>

            </MDBCol>

          </>}

          <Divider />
          <br />

          <MDBCol md="12">
            <FormGroup label="Como você deseja se autenticar no DEI?" labelInfo={<>
              &nbsp;<AppIcon name="help" className="pulse-notification-pgdas" color="blue" style={{ cursor: "pointer" }} onClick={() => this.obs.open_ajuda_dei = true} />
            </>
            }>
              <RadioGroup inline onChange={(e: any) => EmpresaStore.obs.empresa_edit.autenticacao_dei = e.target.value} selectedValue={EmpresaStore.obs.empresa_edit.autenticacao_dei}>
                <Radio label="Certificado do Sócio" value="2" />
                <Radio label="CPF e Senha" value="1" />
                <Radio label="GOV (Certificado)" value="0" />
                <Radio label="GOV (CPF / Senha)" value="3" />
              </RadioGroup>
            </FormGroup>
          </MDBCol>

          {EmpresaStore.obs.empresa_edit.autenticacao_dei == "2" && <>

            <MDBCol md="12">
              <h2 className="title">Certificado do Sócio</h2>
              {EmpresaStore.obs.empresa_edit.certificado_socio
                ? (
                  <>
                    <h3 className="info-cert">
                      Essa empresa possui um certificado em uso. <b />(Validade:{" "} {moment(EmpresaStore.obs.empresa_edit.certificado_socio).format("DD/MM/YYYY")})
                    </h3>

                    <MDBRow md="12" style={{ marginLeft: 0 }}>
                      <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING} position="bottom-left">
                        <Button intent="danger" icon="trash">Excluir Certificado</Button>
                        <div>
                          <H5>Confirmar exclusão?</H5>
                          <p>Atenção, deseja realmente excluir o certificado?</p>

                          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15 }}>
                            <Button className={Classes.POPOVER_DISMISS} style={{ marginRight: 10 }}>Cancelar</Button>
                            <Button intent="danger" className={Classes.POPOVER_DISMISS} onClick={this.deletaCertificado}>Excluir</Button>
                          </div>
                        </div>
                      </Popover>
                    </MDBRow>

                  </>
                )
                : (
                  <>
                    <MDBRow>
                      <MDBCol md="6">
                        <FormGroup label="Selecionar Certificado Digital">
                          <FileInput text={this.obs.nome_certificado} className="bp3-fill bp3-file-input-has-selection input-file-certificado" onInputChange={this.handleFileInputChange} />
                        </FormGroup>
                      </MDBCol>

                      <MDBCol md="4">
                        <FormGroup label="Senha Certificado">
                          <InputGroup autoComplete="new-senha-certificado" name="new-senha-certificado" type="password" onChange={(e: any) => EmpresaStore.obs.empresa_edit.senha_certificado_socio = e.target.value} />
                        </FormGroup>
                      </MDBCol>

                      <MDBCol md="2">
                        <Button onClick={(e) => this.handleImportCertificado()} intent="primary" style={{ marginTop: 26 }}>Importar</Button>
                      </MDBCol>

                    </MDBRow>
                  </>
                )
              }

            </MDBCol>

          </>}

          {EmpresaStore.obs.empresa_edit.autenticacao_dei == "0" && <></>}

          {EmpresaStore.obs.empresa_edit.autenticacao_dei == "1" && <>

            <MDBCol md="12">

              <div style={{ display: "flex" }}>
                <FormGroup label="CPF" labelFor="cpf" style={{ width: "50%" }}>
                  <InputMask
                    className="form-control"
                    mask="999.999.999-99"
                    autoComplete="cpf-gov"
                    name="cpf-gov"
                    value={EmpresaStore.obs.empresa_edit.cpf_sefa}
                    onChange={(e: any) => EmpresaStore.obs.empresa_edit.cpf_sefa = e.target.value}
                  />
                </FormGroup>

                <FormGroup label="Senha" labelFor="senha" style={{ width: "50%", marginLeft: 10 }}>
                  <InputGroup
                    type="password"
                    autoComplete="new-password-gov"
                    name="new-password-gov"
                    placeholder="*********"
                    defaultValue={EmpresaStore.obs.empresa_edit.senha_sefa}
                    onChange={(e: any) => EmpresaStore.obs.empresa_edit.senha_sefa = e.target.value}
                  />
                </FormGroup>
              </div>

            </MDBCol>

          </>}

          {EmpresaStore.obs.empresa_edit.autenticacao_dei == "3" && <>

            <MDBCol md="12">

              <div style={{ display: "flex" }}>
                <FormGroup label="CPF" labelFor="cpf" style={{ width: "50%" }}>
                  <InputMask
                    className="form-control"
                    mask="999.999.999-99"
                    autoComplete="cpf-gov"
                    name="cpf-gov"
                    value={EmpresaStore.obs.empresa_edit.cpf_gov}
                    onChange={(e: any) => EmpresaStore.obs.empresa_edit.cpf_gov = e.target.value}
                  />
                </FormGroup>

                <FormGroup label="Senha" labelFor="senha" style={{ width: "50%", marginLeft: 10 }}>
                  <InputGroup
                    type="password"
                    autoComplete="new-password-gov"
                    name="new-password-gov"
                    defaultValue={EmpresaStore.obs.empresa_edit.senha_gov}
                    onChange={(e: any) => EmpresaStore.obs.empresa_edit.senha_gov = e.target.value}
                  />
                </FormGroup>
              </div>

            </MDBCol>

          </>}

          <Divider />
          <br />

          <MDBCol md="12">
            <FormGroup label="Como você deseja se autenticar no e-CAC?" labelInfo={<>
              &nbsp;<AppIcon name="help" className="pulse-notification-pgdas" color="blue" style={{ cursor: "pointer" }} onClick={() => this.obs.open_ajuda_ecac = true} />
            </>
            }>
              <RadioGroup inline
                onChange={(e: any) => EmpresaStore.obs.empresa_edit.autenticacao_ecac = e.target.value}
                selectedValue={EmpresaStore.obs.empresa_edit.autenticacao_ecac}
              >
                <Radio label="Certificado da Empresa" value="0" />
                <Radio label="Certificado do Contator" value="1" />
              </RadioGroup>
            </FormGroup>
          </MDBCol>

          <Divider />
          <br />

          <MDBCol md="12">
            <FormGroup label="Como você deseja se autenticar no PARCELAMENTO SEFA?" labelInfo={<>
              &nbsp;<AppIcon name="help" className="pulse-notification-pgdas" color="blue" style={{ cursor: "pointer" }} onClick={() => this.obs.open_ajuda_parcelamento = true} />
            </>
            }>
              <RadioGroup inline
                onChange={(e: any) => EmpresaStore.obs.empresa_edit.autenticacao_sefa = e.target.value}
                selectedValue={EmpresaStore.obs.empresa_edit.autenticacao_sefa}
              >
                <Radio label="Certificado da Empresa" value="0" />
                <Radio label="Certificado do Sócio" value="1" />
                <Radio label="Usuário e Senha (Sócio)" value="2" />
              </RadioGroup>
            </FormGroup>

          </MDBCol>

          {EmpresaStore.obs.empresa_edit.autenticacao_sefa == "1" && <>

            <MDBCol md="12">
              {EmpresaStore.obs.empresa_edit.certificado_socio
                ? (
                  <>
                    <h3 className="info-cert">
                      Essa empresa possui um certificado em uso. <b />(Validade:{" "} {moment(EmpresaStore.obs.empresa_edit.certificado_socio).format("DD/MM/YYYY")})
                    </h3>

                    <MDBRow md="12" style={{ marginLeft: 0 }}>
                      <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING} position="bottom-left">
                        <Button intent="danger" icon="trash">Excluir Certificado</Button>
                        <div>
                          <H5>Confirmar exclusão?</H5>
                          <p>Atenção, deseja realmente excluir o certificado?</p>

                          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15 }}>
                            <Button className={Classes.POPOVER_DISMISS} style={{ marginRight: 10 }}>Cancelar</Button>
                            <Button intent="danger" className={Classes.POPOVER_DISMISS} onClick={this.deletaCertificado}>Excluir</Button>
                          </div>
                        </div>
                      </Popover>
                    </MDBRow>

                  </>
                )
                : (
                  <>
                    <MDBRow>
                      <MDBCol md="6">
                        <FormGroup label="Selecionar Certificado Digital">
                          <FileInput text={this.obs.nome_certificado} className="bp3-fill bp3-file-input-has-selection input-file-certificado" onInputChange={this.handleFileInputChange} />
                        </FormGroup>
                      </MDBCol>

                      <MDBCol md="4">
                        <FormGroup label="Senha Certificado">
                          <InputGroup autoComplete="new-senha-certificado" name="new-senha-certificado" type="password" onChange={(e: any) => EmpresaStore.obs.empresa_edit.senha_certificado_socio = e.target.value} />
                        </FormGroup>
                      </MDBCol>

                      <MDBCol md="2">
                        <Button onClick={(e) => this.handleImportCertificado()} intent="primary" style={{ marginTop: 26 }}>Importar</Button>
                      </MDBCol>

                    </MDBRow>
                  </>
                )
              }

            </MDBCol>

          </>}

          {EmpresaStore.obs.empresa_edit.autenticacao_sefa == "2" && <>

            <MDBCol md="12">

              <div style={{ display: "flex" }}>
                <FormGroup label="CPF" labelFor="cpf" style={{ width: "49%", float: "left" }}>
                  <InputMask
                    className="form-control"
                    mask="999.999.999-99"
                    autoComplete="cpf-socio"
                    name="cpf-socio"
                    value={EmpresaStore.obs.empresa_edit.cpf_socio}
                    onChange={(e: any) => EmpresaStore.obs.empresa_edit.cpf_socio = e.target.value}
                  />
                </FormGroup>

                <FormGroup label="Senha" labelFor="senha" style={{ width: "49%", float: "left", marginLeft: "2%" }}>
                  <InputGroup
                    type="password"
                    autoComplete="new-password-socio"
                    name="new-password-socio"
                    placeholder="*********"
                    defaultValue={EmpresaStore.obs.empresa_edit.senha_socio}
                    onChange={(e: any) => EmpresaStore.obs.empresa_edit.senha_socio = e.target.value}
                  />
                </FormGroup>
              </div>
            </MDBCol>

          </>}

          <Divider />
          <br />

          <MDBCol md="12">

            <Switch
              label="Receber uma cópia das PARCELAS por E-mail"
              alignIndicator="right"
              checked={EmpresaStore.obs.empresa_edit.send_parcelas}
              onChange={(e: any) => EmpresaStore.obs.empresa_edit.send_parcelas = e.target.checked}
              style={{ width: "max-content", fontWeight: "bold" }}
            />

            {EmpresaStore.obs.empresa_edit.send_parcelas ? (<>

              <FormGroup helperText="Insira um e-mail para receber as cópias dos arquivos, para mais de um e-mail separar por vírgula.">
                <InputGroup
                  type="text"
                  placeholder="email@email.com"
                  value={EmpresaStore.obs.empresa_edit.parcelamentos_email}
                  onChange={(e: any) => EmpresaStore.obs.empresa_edit.parcelamentos_email = e.target.value}>
                </InputGroup>
              </FormGroup>

            </>) : <br />}

          </MDBCol>

          <Divider />
          <br />

          <MDBCol md="12">

            <Switch
              label="Receber uma cópia das PARCELAS por WhatsApp"
              alignIndicator="right"
              checked={EmpresaStore.obs.empresa_edit.send_parcelas_message}
              onChange={(e: any) => EmpresaStore.obs.empresa_edit.send_parcelas_message = e.target.checked}
              style={{ width: "max-content", fontWeight: "bold" }}
            />

            {EmpresaStore.obs.empresa_edit.send_parcelas_message ? (<>

              <FormGroup helperText="Insira um número com DDD para receber as cópias dos arquivos.">
                <PhoneInput
                  country={'br'}
                  enableSearch
                  excludeCountries={['us','ua','ru']}
                  value={EmpresaStore.obs.empresa_edit.parcelamentos_numero}
                  onChange={phone => EmpresaStore.obs.empresa_edit.parcelamentos_numero = phone }
                  inputClass="phone-input"
                  searchClass="phone-input-search"
                  disableSearchIcon
                />

              </FormGroup>

            </>) : <br />}

          </MDBCol>

          <Divider />

        </div>

        <Dialog isOpen={this.obs.open_termos_dec_sefa}>
          <div className={Classes.DIALOG_BODY}>
            <div style={{
              padding: "1.5cm",
              overflow: "auto",
              marginTop: "-80px",
            }}>

              <div style={{ textAlign: "center", marginBottom: 15, fontSize: 14 }}>
                <b>Termo de Responsabilidade para Leitura Automática de Domicílios Eletrônicos do Contribuinte</b>
              </div>

              <div style={{ textAlign: "justify", overflow: "auto", height: 450, padding: 15, border: "1px solid #000", borderRadius: 10, fontSize: 12 }}>
                <b>1. Introdução</b>
                <p>O presente Termo de Responsabilidade tem como objetivo estabelecer as responsabilidades e obrigações da empresa contratante do Sistema FIPO e da empresa desenvolvedora do sistema ("FIPO") em relação à leitura automática dos domicílios eletrônicos do Contribuinte ("DEC") dos contribuintes na Secretaria de Estado da Fazenda ("SEFA").</p>

                <b>2. Definições</b>
                <ul>
                  <li><strong>Contratante:</strong> Empresa que contratou o Sistema FIPO para automatizar a gestão de suas obrigações fiscais.</li>
                  <li><strong>FIPO:</strong> Empresa desenvolvedora do Sistema FIPO, responsável pela leitura automática dos DEC dos contribuintes na SEFA.</li>
                  <li><strong>Sistema FIPO:</strong> Software desenvolvido pela FIPO para automatizar a gestão de obrigações fiscais, incluindo a leitura automática dos DEC dos contribuintes na SEFA.</li>
                  <li><strong>DEC:</strong> Endereço eletrônico cadastrado pelo contribuinte na SEFA para recebimento de intimações, notificações e outros atos administrativos.</li>
                </ul>

                <p><a href="https://app.sefa.pa.gov.br/pservicos/autenticacao?servico=aHR0cHM6Ly9hcHAuc2VmYS5wYS5nb3YuYnIvZGVjLyMv" target="_black">https://app.sefa.pa.gov.br/pservicos/autenticacao?servico=aHR0cHM6Ly9hcHAuc2VmYS5wYS5nb3YuYnIvZGVjLyMv</a></p>

                <b>3. Leitura Automática dos DEC</b>
                <p>O Sistema FIPO está autorizado a ler automaticamente os DEC dos contribuintes na SEFA, em nome da Contratante.</p>

                <b>4. Responsabilidades da Contratante</b>
                <ul>
                  <li>A Contratante é a única responsável por garantir que o Sistema FIPO esteja configurado corretamente para ler os DEC.</li>
                  <li>A Contratante é responsável por verificar a autenticidade dos DEC antes de autorizar sua leitura pelo Sistema FIPO.</li>
                  <li>A Contratante é responsável por manter seus dados cadastrais atualizados na SEFA.</li>
                  <li>A Contratante é responsável por qualquer erro ou omissão na leitura dos DEC pelo Sistema FIPO.</li>
                </ul>

                <b>5. Responsabilidades da FIPO</b>
                <ul>
                  <li>Disponibilizar a funcionalidade de leitura automática dos DEC no Sistema FIPO.</li>
                  <li>Manter a segurança da informação dos DEC.</li>
                  <li>Notificar a Contratante em caso de qualquer problema com a leitura dos DEC pelo Sistema FIPO.</li>
                </ul>

                <b>6. Cancelamento da Autorização</b>
                <p>A Contratante poderá cancelar a autorização para leitura automática dos DEC pelo Sistema FIPO a qualquer momento.</p>

                <b>7. Disposições Gerais</b>
                <ul>
                  <li>O presente Termo de Responsabilidade é parte integrante do contrato de adesão ao Sistema FIPO.</li>
                  <li>A FIPO poderá alterar este Termo a qualquer tempo, mediante comunicação à Contratante.</li>
                </ul>

                <b>8. Aceite</b>
                <p>Ao utilizar o Sistema FIPO para leitura automática dos DEC, a Contratante declara ter lido e concordado com os termos do presente Termo de Responsabilidade.</p>
              </div>

              <div style={{ textAlign: "center", marginTop: 20 }}>
                <Button intent="danger" onClick={() => this.handleNaoAceita()} style={{ marginRight: 20, height: 35, width: 90 }}>Não Aceito</Button>
                <Button intent="primary" onClick={() => this.handleAceita()} style={{ height: 35, width: 90 }}>Aceito</Button>
              </div>

            </div>
          </div>

        </Dialog>

        <InfoModal open={this.obs.open_ajuda} onClose={() => this.obs.open_ajuda = false} texto_info={`
          <b>Formas de autenticação na SEFA:</b><br /><br />
          <b>1. Certificado do Sócio</b> – Requer a utilização do Certificado Digital (A1) do sócio da empresa.<br /><br />
          <b>2. CPF e Senha</b> – Modalidade temporariamente indisponível.<br /><br />
          <b>3. GOV (Certificado)</b> – Acesso realizado com o Certificado Digital (A1) da empresa.<br /><br />
          <b>4. GOV (CPF e Senha)</b> – Acesso utilizando as credenciais do GOV.br vinculadas ao CPF do sócio da empresa.<br /><br />
          <br />
          <b>Importante:</b> As autenticações via GOV.br somente funcionarão se a conta do sócio estiver com a autenticação em duas etapas desativada.<br /><br />
        `} />

        <InfoModal open={this.obs.open_ajuda_ecac} onClose={() => this.obs.open_ajuda_ecac = false} texto_info={`
          <b>Formas de autenticação no e-CAC:</b><br /><br />
          <b>1. Certificado da Empresa</b> – Acesso realizado com o Certificado Digital (A1) da empresa.<br /><br />
          <b>2. Certificado do Contador</b> – Acesso realizado com o Certificado Digital (A1) do contador. Esse certificado pode ser cadastrado no caminho: <b>Perfil > Contador da Plataforma > Certificado do Contador</b>.</b><br />
          <br />
          <b>Importante:</b> As autenticações via GOV.br somente funcionarão se a conta estiver com a autenticação em duas etapas desativada.<br /><br />
        `} />

        <InfoModal open={this.obs.open_ajuda_parcelamento} onClose={() => this.obs.open_ajuda_parcelamento = false} texto_info={`
          <b>Formas de autenticação no PARCELAMENTO SEFA:</b><br /><br />
          <b>1. Certificado da Empresa</b> – Acesso realizado com o Certificado Digital (A1) da empresa.<br /><br />
          <b>2. Certificado do Sócio</b> – Requer a utilização do Certificado Digital (A1) do sócio da empresa.<br /><br />
          <b>3. CPF e Senha (Sócio)</b> – Requear o CPF e SENHA do portal SEFA do sócio da empresa.<br /><br />
        `} />

        <InfoModal open={this.obs.open_ajuda_dei} onClose={() => this.obs.open_ajuda_dei = false} texto_info={`
          <b>Formas de autenticação na SEFA:</b><br /><br />
          <b>1. Certificado do Sócio</b> – Requer a utilização do Certificado Digital (A1) do sócio da empresa.<br /><br />
          <b>2. CPF e Senha</b> – Requer o CPF e SENHA de acesso do portal SEFA.<br /><br />
          <b>3. GOV (Certificado)</b> – Acesso realizado com o Certificado Digital (A1) da empresa.<br /><br />
          <b>4. GOV (CPF e Senha)</b> – Acesso utilizando as credenciais do GOV.br vinculadas ao CPF do sócio da empresa.<br /><br />
          <br />
          <b>Importante:</b> As autenticações via GOV.br somente funcionarão se a conta estiver com a autenticação em duas etapas desativada.<br /><br />
        `} />

      </>
    );
  }
}
